/* eslint-disable camelcase */
import { Component } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import IncentivePerformance from './incentive-performance';
import { currentUserGroup } from '../../../utils/tokenUtils';

import './style.css';
import expand from '../../../assets/img/performances/Expand@2x.png';
import collapse from '../../../assets/img/performances/Collapse@2x.png';

class SellItPerformance extends Component {
  state = {
    open: false
  };

  toggleContent = () => {
    this.setState({ open: !this.state.open });
  };

  componentDidMount() {
    if (currentUserGroup() === 'staff') {
      this.setState({open: true});
    }
  }

  render() {
    const {
      correct_to_date, customer_number, name, incentives, outlet
    } = this.props;

    const { open } = this.state;

    let date = correct_to_date.split('/');
    date = `${date[1]}/${date[0]}/${date[2]}`;

    return (
      <div>
        <div className="incentive-performances">
          <Card className={open ? 'panel-open' : 'panel-closed'}>
            <Card.Header>
              <div className="card-title" onClick={this.toggleContent}>
                <Row>
                  <Col lg={10}>
                    {`${name}`} {customer_number}
                  </Col>
                  <Col lg={2}>
                    <img className="panel-toggle" src={open ? collapse : expand} />
                  </Col>
                </Row>
              </div>
            </Card.Header>
            {this.state.open && (
              <Card.Body>
                {incentives.map((incentive, key) => (
                  <IncentivePerformance
                    key={key}
                    outlet={outlet}
                    incentive={incentive}
                    correct_to_date={date}
                  />
                ))}
              </Card.Body>
            )}
          </Card>
        </div>
      </div>
    );
  }
}

export default SellItPerformance;
